var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":require("../assets/attention.png"),"alt":"Smart Image"}})]),_c('div',{staticClass:"hello"},[_c('h1',[_vm._v("opps!")]),_c('p',[_vm._v(" Please request for another quotation link ")])])])
}]

export { render, staticRenderFns }